import data from '../../../data/data.json'; // TEMP

function fetchData({ path }) {
    return path.success({ data });
}
export default fetchData;



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/fetchData.js